export default "__VITE_ASSET__BDrRGxxc__"